module.exports = __webpack_public_path__ + "static/story-9782311914c3a1d6625182859091b698.png";